import { render, staticRenderFns } from "./ChatBotBeauty.vue?vue&type=template&id=4dd8487a&scoped=true&"
import script from "./ChatBotBeauty.vue?vue&type=script&lang=ts&"
export * from "./ChatBotBeauty.vue?vue&type=script&lang=ts&"
import style0 from "./ChatBotBeauty.vue?vue&type=style&index=0&id=4dd8487a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4dd8487a",
  null
  
)

export default component.exports